var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._g(_vm._b({class:['totem-draggable', _vm.direction],on:{"start":function($event){_vm.drag=true},"end":function($event){_vm.drag=false}}},'draggable',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }